import React from 'react';
import ReportPaymentHeader from './reportPaymentHeader';

const ReportPaymentDesktop = ({
    headerReportPaymentCheckboxClickHandler,
    reportPaymentGridData,
    setReportPaymentGridData,
    allSelected,
    setAllSelected,
    winWidth
}) => {
    return (
        <>
            <ReportPaymentHeader
                reportPaymentGridData={reportPaymentGridData}
                setReportPaymentGridData={setReportPaymentGridData}
                headerReportPaymentCheckboxClickHandler={
                    headerReportPaymentCheckboxClickHandler
                }
                allSelected={allSelected}
                setAllSelected={setAllSelected}
                winWidth={winWidth}
            />
        </>
    );
};
export default ReportPaymentDesktop;
